export default "__VITE_ASSET__DFEjYCq4__"